import {DataSource} from '@angular/cdk/collections';
import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {Router} from '@angular/router';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ToastrService} from 'ngx-toastr';
import {BehaviorSubject, Observable, pipe, Subscription} from 'rxjs';
import {Message} from 'src/app/core/class/message';
import { Paginate } from "../search-document-mine.component";
import {DocumentService} from 'src/app/core/services/document.service';
import {ProcessingService} from 'src/app/core/services/processing.service';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {SearchDocumentComponent} from '../../search-document/search-document.component';
import {SearchDocumentMineComponent} from '../search-document-mine.component';
import {CommonService} from '../../../../../../../core/services/common.service';
import { finalize } from 'rxjs/operators';
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-multiple-sign-dialog',
  templateUrl: './multiple-sign-dialog.component.html',
  styleUrls: ['./multiple-sign-dialog.component.scss']
})

export class MultipleSignDialogComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;

  dataSource: any;

  tmp: any;

  isProcess = false;

  isStop = false;

  isDraftAll = false;

  isShowProgress = false;
  checklenghtRun = true;

  timeOut: any;

  paginate: Paginate;
  page = 0;
  pageSize = 10;

  percent: 0;

  documents = new Document();
  listData = [];
  listDataPopup = [];

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'result',
    'detail',
    // 'symbol',
  ];
  timeout: any;
  subcription: Subscription = new Subscription();

  subtitle: string;
  subtitle1: string;
  thresholdContract: string;
  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    public dialogRef: MatDialogRef<MultipleSignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private message: Message,
    private commonService: CommonService,
    private router: Router,
    private documentService: DocumentService,
    private processingService: ProcessingService,
    private toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    this.subtitle = data.subTitleDraftAll ? data.subTitleDraftAll : '';
    this.subtitle1 = data.subTitleDraftAllTotal ? data.subTitleDraftAllTotal : '';
    if ( data.isDraftAll === 2) {
      this.isDraftAll = true;
      this.subtitle1 = '';
    }
  }


  /**
   * Initialize data.
   */
  ngOnInit() {
    this.documentService.getThresholdContract({code: 'sign_flow_multi_sign.threshold'}).subscribe(res => {
      this.thresholdContract = this.message.getMessage('messages.note_sign_all_contract_draft').replace('{0}', res ? res.data.value : 5000);
    })
    this.listDataPopup = [];
    this.listData = [];
    this.listDataPopup = this.data.selectedDraftAll;
    if (this.data.isProcess) {
      this.onProcessing();
      this.checklenghtRun = false;
    }
    if (this.data.signContractId ) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        }
        this.dataSource = res.data.lotDetails;
        this.listDataPopup = this.dataSource;
      });
    } else {
      if (this.data.dataSelected === []) {
        this.processingService.processingMultiSignStatus.next(false);
      }
      const selectedValues = Array.from(this.data.selectedDraftAll.values());
      let draftStatusValue;
      if (!this.isDraftAll) {
        draftStatusValue = selectedValues.filter((v: any) => v.status === 1);
      } else {
        draftStatusValue = selectedValues;
      }
      this.dataSource = draftStatusValue;
      this.listDataPopup = this.dataSource;
    }
    this.isProcess = this.data.isProcess ? this.data.isProcess : false;
    this.isShowProgress = this.isProcess;
    // if (this.isShowProgress) {
    // } else {
    //   this.listDataPopup.forEach((ele, i) => {
    //     if (i < 10 ) {
    //       this.listData.push(ele);
    //     }
    //     ele.order = i + 1;
    //   });
    // }
    // if (this.isProcess) {
    //   for (const item of this.listDataPopup) {
    //     item.status = 'PROCESSING';
    //   }
    // }

    // console.log(this.listDataPopup);
    this.listDataPopup.forEach((ele, i) => {
      if (i < 10 ) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });

    this.paginate = {
      currentPage: this.page,
      pageSize: this.pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / this.pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / this.pageSize),1),
      no: this.counter(this.pageSize, this.page * this.pageSize + 1)
    };
    if (!this.data.isProcess || this.listDataPopup.length > 0) {
      this.onProcessing();
    }
    this.processingService.processingMultiSignStatus.subscribe(res => {
      this.isShowProgress = res;
    });
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    //  this.actions.next(MultipleSignDialogComponent.CLOSE_ACTION);
    this.dialogRef.close();
    //  this.data.signContractId = 'MjIja2tzJjIjKjY0NA'
    //     this.processingService.processingMultiSignStatus.next(false)
    //     this.documentService.signContractFlowCancel(this.data.signContractId).subscribe(rs => {
    //       this.toastr.success(rs)
    //     });
  }

  onProcessing() {
    if (this.data.signContractId) {
      this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
        if (!res || !res.data.lotDetails) {
          return;
        }
        this.dataSource = res.data.lotDetails;
        this.listDataPopup = this.dataSource;
        this.onFilterData(this.page, this.pageSize);
        this.processingService.processingDataRun.next(this.listDataPopup);
      });
    }
    const proccesingTaskSub = this.processingService.processingMultiSign.subscribe(ref => {
      const process = ref;
      if (process > 0) {
        this.percent = process;
        if (this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            this.dataSource = res.data.lotDetails;
            this.listDataPopup = this.dataSource;
            this.onFilterData(this.page, this.pageSize);
            this.processingService.processingDataRun.next(this.listDataPopup);
          });
        }
        if (process === 100 && this.data.signContractId) {
          this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
            if (!res || !res.data.lotDetails) {
              return;
            }
            this.dataSource = res.data.lotDetails;
            this.listDataPopup = this.dataSource;
            this.onFilterData(this.page, this.pageSize);
            this.processingService.processingDataRun.next(this.listDataPopup);
          });
          this.isStop = true;
          this.timeOut = setTimeout(() => {
            this.isShowProgress = false;
          }, 2000);
        }
      }
      // } else if (this.percent) {
      //   this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
      //     if (!res || !res.data.lotDetails) {
      //       return;
      //     }
      //     this.dataSource = res.data.lotDetails;
      //   });
      //   this.percent = 0;
      // }
    });
    // this.subcription.add(proccesingTaskSub);
    // this.documentService.signContractFlowInfo(this.data.signContractId).subscribe(res => {
    //   if (!res || !res.data.lotDetails) {
    //     return;
    //   }
    //   this.dataSource = res.data.lotDetails;
    // });
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
    this.processingService.processingMultiSign.next(0);
    this.blockUI.reset();
    this.blockUI.start('');
    let body;
    body = this.listDataPopup.map(item => {
      return item.id;
    });
    this.documentService.createSignContractFlow({contractIds: body})
      .pipe(finalize(() => this.blockUI.stop()))
      .subscribe({
        next: rs => {
          if (rs && rs.success) {
            this.checklenghtRun = false;
            // this.subtitle1 = this.commonService.format(this.message.getMessage('messages.sign_list_docs_draft_total_runing'), body.length);
            this.subtitle = '';
            this.isProcess = true;
            this.isShowProgress = true;
            if (!this.isDraftAll) {
              this.processingService.processingCheckMan.next(1);
              localStorage.setItem('checkMan', '1' );
            } else {
              this.processingService.processingCheckMan.next(4);
              localStorage.setItem('checkMan', '4' );
            }
            this.processingService.processingMultiSignStatus.next(this.isProcess);
            this.processingService.processingDataRun.next(this.listDataPopup);
            this.data.signContractId = rs.data;
            this.data.onClickConfirmButton();
            this.onProcessing();
            this.onFilterData(this.page, this.pageSize);
            this.blockUI.stop();
          } else {
            this.blockUI.stop();
            this.toastr.error(rs.message);
          }
        },
        error: err => {
          this.blockUI.stop();
        }
      });
  }

  onClickStopSign() {
    // show confirm poup.
    const popup = this.dialog.open(WarningComponent, {
      width: '30%',
      data: 'messages.sign_multi_stop_confirm'
    });

    popup.afterClosed().subscribe(rs => {
      if (rs) {
        // call to server for stopping sign.
        const signContractId = this.data.signContractId;
        this.isStop = true;
        this.processingService.processingMultiSignCancel.next(this.isStop);
        this.documentService.signContractFlowCancel(signContractId).subscribe(
          (res) => {
            if (res && res.success) {
              this.processingService.processingMultiSignStatus.next(false);
              this.processingService.processingMultiSignCancel.next(this.isStop);
              if (!this.isDraftAll) {
                this.processingService.processingCheckMan.next(1);
                localStorage.setItem('checkMan', '1' );
              } else {
                this.processingService.processingCheckMan.next(4);
                localStorage.setItem('checkMan', '4' );
              }
              this.isShowProgress = false;
              this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
                if (!res || !res.data.lotDetails) {
                  return;
                }
                this.dataSource = res.data.lotDetails;
              });
              this.toastr.success(this.message.getMessage('messages.sign_multi_stop'));
            } else {
              // this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
              //   if (!res || !res.data.lotDetails) {
              //     return;
              //   }
              //   this.dataSource = res.data.lotDetails;
              // });
              this.toastr.error(this.message.getMessage('messages.sign_multi_stop_fail'));
            }
          },
          (err) => {
          },
          () => {
            // this.documentService.signContractFlowInfo(signContractId).subscribe(res => {
            //   if (!res || !res.data.lotDetails) {
            //     return;
            //   }
            //   this.dataSource = res.data.lotDetails;
            // });
          }
        );
      }
    });
  }

  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
        return this.message.getMessage('sign_contract_flow.error');
      case 'PROCESSING':
      case 'CANCEL':
        return this.message.getMessage('sign_contract_flow.process');
      case 'DONE':
        return this.message.getMessage('sign_contract_flow.success');
      default:
        return '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red', 'border': '1px solid red', 'border-radius': '5px'};
      case 'PROCESSING':
      case 'CANCEL':
        return {'color': 'blue', 'border': '1px solid blue', 'border-radius': '5px'};
      case 'DONE':
        return {'color': 'green', 'border': '1px solid green', 'border-radius': '5px'};
      default:
        return {};
    }
  }
  onFilterData(page: number = 0, pageSize: number = 10) {
    if(this.isShowProgress && this.checklenghtRun){
      this.checklenghtRun = false;
      this.subtitle1 = this.commonService.format(this.message.getMessage('messages.sign_list_docs_draft_total_runing'), this.listDataPopup.length);
    }
    this.page = page;
    this.pageSize = pageSize;
    this.listData = [];
    const a: number = page * pageSize;
    this.listDataPopup.forEach((ele, i) => {
      if (a <= i && i < a + pageSize) {
        this.listData.push(ele);
      }
      ele.order = i + 1;
    });
    this.paginate = {
      currentPage: page,
      pageSize: pageSize,
      totalRow: this.listDataPopup.length,
      totalPage: Math.ceil(this.listDataPopup.length / pageSize),
      totalPageArray: this.counter(Math.ceil(this.listDataPopup.length / pageSize),1),
      no: this.counter(pageSize, page * pageSize +1)
    };
  }

  counter(index: number , from: number){
    return new Array(index).fill(0).map((x, i: number) => i + from);
  }

}
